const FORMATS = ['jpeg', 'png', 'jpg', 'pdf', 'doc', 'docx']
const MAX_SIZE = Math.pow(1024, 2)

const validateFile = (
  file: File,
  formats = FORMATS,
  maxSize = MAX_SIZE
): string | null => {
  if (file.size > maxSize) {
    return 'Недопустимый размер файла'
  }

  const ext = file.name.split('.').pop() ?? ''
  if (!formats.map((i) => i.toLowerCase()).includes(ext.toLowerCase())) {
    return 'Неверный формат файла'
  }

  return null
}

export { validateFile }
